import Navbar from "../components/portfolio/Navbar";
import Footer from "../components/portfolio/Footer";
import { Outlet } from "react-router-dom";

function PortfolioLayout() {
  return (
    <div className="portfolio-shell">
      <Navbar />
      <main className="main portfolio-main">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

export default PortfolioLayout